import { render, staticRenderFns } from "./explore3.vue?vue&type=template&id=85a0364a&scoped=true&"
import script from "./explore3.vue?vue&type=script&lang=js&"
export * from "./explore3.vue?vue&type=script&lang=js&"
import style0 from "./explore3.vue?vue&type=style&index=0&id=85a0364a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a0364a",
  null
  
)

export default component.exports